import "../../../css/Landing.css"
import SelectCertType from "./SelectCertType";
import { Toaster } from "react-hot-toast";
import { resetCertificateFlow } from "../../redux/actions/TokneAction";
import { resetAdminToken } from "../../redux/actions/AdminPortalAction";
import { persistor } from "../../redux/Store";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getServiceInfo } from "../../../api/MoadianService";
import { useNavigate } from "react-router-dom";
import CounselingPhone from "./CounselingPhone";
import ValidatKey from "./ValidateKey";
import SignFactor from "./SignFactor";

const LandingPage = () => {

    const [errorMessage, setErrorMessage] = useState('');

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        // Clear persisted state so next user does not get previous user's CSR/data
        persistor.purge();
        dispatch(resetCertificateFlow());
        dispatch(resetAdminToken());

        getServiceInfo().then(response => {

            if (!response?.data?.isActive) {
                setErrorMessage(response?.data?.message)
            }

        }).catch(error => {
            if (error.code == 'ERR_NETWORK') {
                setErrorMessage('بدليل در دسترس نبودن سرويس‌هاي استعلامي ثبت احوال، گواهيت قادر به ارائه خدمات نيست. در صورت ضرورت دريافت گواهي و كليد خصوصي با شماره ۹۱۰۱۴۶۴۸ - ۰۲۱(داخلي 404) يا شماره 09329640013 تماس بگيريد.')
                // setErrorMessage('ارتباط با شبکه قطع است. اتصال اینترنت خود را بررسی کنید.')
            } else if (error?.response?.data?.message) {
                setErrorMessage(error?.response?.data?.message)
            } else {
                setErrorMessage("امکان برقراری ارتباط با سامانه امضا دیجیتال فراهم نیست لطفا مجددا تلاش کنید.")
            }
        })

    }, [])

    return (
        <>
            <Toaster />
            {errorMessage &&
                <div class="alert alert-danger mx-5 mt-5" role="alert">
                    {errorMessage}
                </div>
            }

            <div className={`my-5 landing-container`}>

                <div className="row m-3 m-md-5 my-5">
                    <div className="landing-box p-3 px-4">

                        <p className="landing-box-title">
                            <span className="landing-lable position1">
                                <span className="landing-lable-border">1</span>
                            </span>
                            دریافت گواهی امضای دیجیتال
                        </p>
                        <p className="landing-box-text">برای دریافت گواهی امضای دیجیتال و کلید عمومی و خصوصی خود ابتدا نوع گواهی را انتخاب کنید.</p>

                        <SelectCertType errorMessage={errorMessage} />
                    </div>
                </div>

                <div className="row m-3 m-md-5 my-5 justify-content-between">

                    <div className="col-12 col-md-6 landing-box p-3 px-4">

                        <div>
                            <p className="landing-box-title">
                                <span className="landing-lable position2">
                                    <span className="landing-lable-border less-padding">2</span>
                                </span>
                                دریافت شناسه یکتا مالیاتی
                            </p>
                            <p className="landing-box-text">جهت مشاوره در رابطه با دریافت شناسه یکتا مالیاتی، شماره موبایل خود را وارد کنید.</p>

                            <CounselingPhone />
                        </div>
                    </div>

                    <ValidatKey />
                </div>

                <div className="row m-3 m-md-5 my-5">
                    <div className="landing-box p-3 px-4">

                        <div className="row">
                            <p className=" col-9 landing-box-title title-disable">
                                <span className="landing-lable position3">
                                    <span className="landing-lable-border border-disable">3</span>
                                </span>
                                امضا صورتحساب الکترونیکی</p>
                            <div className="col-3 text-start">
                                <button className="soon-btn px-3 py-1">به زودی</button>
                            </div>
                        </div>
                        <p className="landing-box-text text-disable">بعد از دریافت گواهی و شناسه یکتا برای امضای صورتحساب الکترونیکی فایل خودرا بارگذاری کنید.</p>
                        <SignFactor />
                    </div>
                </div>

                {/* <div className="row m-3 m-md-5 my-5">
                    <div className="landing-box p-3 px-4">


                        <p className="landing-box-title">
                            <span className="landing-lable position1">
                                <span className="landing-lable-border">!</span>
                            </span>
                            شرکت های معتمد</p>
                        <p className="landing-box-text">برای ارسال صحیح صورتحساب‌ها در قالبی استاندارد می‌توانید از شرکت‌های معتمد استفاده کنید.</p>

                        <div className="row justify-content-start justify-content-md-center px-md-5">
                            <div className="col-6 col-md-3">
                                <img src={require("../../../image/bime-razi.png")} />
                            </div>
                            <div className="col-6 col-md-3">
                                <img src={require("../../../image/bime-parsian.png")} />
                            </div>
                            <div className="col-6 col-md-3 mt-4 mt-md-0">
                                <img src={require("../../../image/bime-alborz.png")} />
                            </div>
                        </div>
                    </div>
                </div> */}

            </div>
        </>
    )
}

export default LandingPage;